import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CxbLogo from '../../assets/CxbLogo';
import { AuthContext } from '../../contextStore/AuthContext';
import './MobileMenu.css';

function MobileMenu({ open, onClose }) {
  const { t } = useTranslation();
  const { user } = React.useContext(AuthContext);

  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  if (!open) return null;

  return (
    <>
      <div className="mobileMenuOverlay" onClick={onClose} aria-hidden="true" />
      <div className="mobileMenuDrawer">
        <div className="mobileMenuHeader">
          <Link to="/" onClick={onClose}>
            <CxbLogo />
          </Link>
          <button
            type="button"
            className="mobileMenuClose"
            onClick={onClose}
            aria-label={t('header.closeMenu')}
          >
            ✕
          </button>
        </div>
        <nav className="mobileMenuNav">
          <Link to="/" onClick={onClose}>
            {t('navigation.home')}
          </Link>
          <Link to="/search" onClick={onClose}>
            {t('common.search')}
          </Link>
          {user ? (
            <>
              <Link to="/dashboard" onClick={onClose}>
                {t('navigation.myCxb')}
              </Link>
              <Link to="/dashboard/saved" onClick={onClose}>
                {t('navigation.favorites')}
              </Link>
              <Link to="/messages" onClick={onClose}>
                {t('navigation.messages')}
              </Link>
              <Link to="/messages/buying" onClick={onClose}>
                {t('navigation.buySell')}
              </Link>
              <Link to="/notifications" onClick={onClose}>
                {t('navigation.notifications')}
              </Link>
              <Link to={`/profile/${user.uid}`} onClick={onClose}>
                {t('common.profile')}
              </Link>
              <Link to="/profile/edit" onClick={onClose}>
                {t('navigation.settings')}
              </Link>
            </>
          ) : (
            <Link to="/login" onClick={onClose}>
              {t('common.login')}
            </Link>
          )}
          <Link to="/create" onClick={onClose} className="mobileMenuSell">
            + {t('common.sell')}
          </Link>
          <Link
            to={{ pathname: '/create', state: { category: 'Investment' } }}
            onClick={onClose}
            className="mobileMenuSell mobileMenuSell--investment"
          >
            + {t('header.createCategory.investment')}
          </Link>
          <Link
            to={{ pathname: '/create', state: { category: 'Services' } }}
            onClick={onClose}
            className="mobileMenuSell mobileMenuSell--services"
          >
            + {t('header.createCategory.services')}
          </Link>
          <Link
            to={{ pathname: '/create', state: { category: 'Bonuses' } }}
            onClick={onClose}
            className="mobileMenuSell mobileMenuSell--bonuses"
          >
            + {t('header.createCategory.bonuses')}
          </Link>
        </nav>
      </div>
    </>
  );
}

export default MobileMenu;
